export class DeviceParamGatewayV3CronLirisSyncTime {
    public every: string =  '40m';
    public enable: number = 0;
}
